import effects from 'app/effects/effects'
import { useDispatch } from 'react-redux'

import { useMutation } from '@tanstack/react-query'
import { getAllCategories } from 'app/store/categories'
import { reduce } from 'ramda'

export default () => {
  const dispatch = useDispatch()

  const categories = useMutation({
    mutationFn: async () => {
      const response = await effects.apis.getGroupCategories()
      return response
    },
    onSuccess: (response) => {
      dispatch(getAllCategories(response))
    },
  })

  const mapGroupCategories = (groupCategories) => {
    return reduce(
      (acc, groupCategory) => {
        return [
          ...acc,
          ...groupCategory.categories.data.map((category) => {
            return {
              ...category,
              categoryGroupName: groupCategory.name,
              categoryGroupID: groupCategory.id,
              optionTitle: `${groupCategory.name}/${category.name}`,
              groupBy: groupCategory.name,
            }
          }),
        ]
      },
      [],
      groupCategories,
    )
  }

  return {
    categories,
    mapGroupCategories,
  }
}
